exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".stepButtons--1_KEO {\n  display: flex;\n  flex-direction: row;\n}\n\n.step--1-6W2 {\n  font-size: 1rem;\n}\n\n", ""]);

// exports
exports.locals = {
	"stepButtons": "stepButtons--1_KEO",
	"step": "step--1-6W2"
};